import {customAxios} from "../customAxios";
import { useState} from "react";
import { VehicleImportOverride} from "../../model/Vehicle";

export function useDeleteVehicleOverride() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    async function execute(vehicleId: number, importId: number) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await deleteVehicleOverride(vehicleId, importId);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, error, execute
    };
}

export async function deleteVehicleOverride(vehicleId: number, importId: number,): Promise<void> {
    const response = await customAxios.delete<void>(`/v1/vehicle/${vehicleId}/import/${importId}/override`,);
    return response.data;
}

